const WHITE = '#FFF';

export const validateColor = (color, defaultColor) => {
  if ((color || '').match(/^#([\dA-Fa-f]{3}){1,2}$/)) {
    return color;
  }
  return defaultColor || WHITE;
};
